/* Copyright (c) Epiphyte LLC 2022. All rights reserved.
Author: Fernandez-Alcon, Jose <jose@epiphyte.io>
 */

import React, {useEffect, useState} from "react";
import {
    Box,
    Button, Form, FormField, Layer,
    Page,
    PageContent,
    TextArea, TextInput, Text,
    FileInput,
    Heading,
    Select
} from 'grommet'
import {
    addProduceToUser, getUser,
} from "API/API";
import {
    uploadProduceImage
} from "API/Storage";
import {v4 as uuidv4} from 'uuid';
import { PageHeader } from 'grommet/components/PageHeader'
import MyProduce from "Components/MyProduce";
import { useAuth0 } from "@auth0/auth0-react";





type Props = {}

const Dashboard: React.FC<Props> = (props) => {
    const [refresh, setRefresh] = useState<boolean>(false);
    const [imageFile, setImageFile] = useState<any>();
    const [showModal, setShowModal] = useState(false);
    const [value, setValue] = useState({});
    const [produceType, setProduceType] = useState("");
    const [description, setDescription] = useState("");
    const [profileLoaded, setProfileLoaded] = useState<boolean>(false)
    const [address, setAddress] = useState<API.Address>();

    const { user } = useAuth0();

    if(!profileLoaded) {
        getUser(user.sub).then(res => {
            setProfileLoaded(true)
            setAddress(res.Address)
        })
    }

    const imageUUID = uuidv4();

    useEffect(() => {
        setRefresh(false)
    }, [refresh])



    const submitAction = async (produce) => {
        produce.Description = description
        produce.ProduceType = produceType
        produce.Image = imageUUID
        produce.Location = address.Location

        console.log(produce)
        uploadProduceImage(imageFile, imageUUID, imageFile.type)
        addProduceToUser(user.sub, produce)


        setShowModal(false)

        setRefresh(true)
    }

    return (
        <Page kind={"wide"} >
            <PageHeader
                title={"My Produce"}
                subtitle={"All your veggies to trade"}
                margin={"medium"}
                actions={ <Button primary label={"Add Produce"} onClick={() => setShowModal(true)} />}
            />

            <PageContent
                responsive={true}
                // background="light-3"
            >
                {!refresh && <MyProduce User={user}/>}
            </PageContent>

            {showModal && (
                <Layer
                    onEsc={() => setShowModal(false)}
                    onClickOutside={() => setShowModal(false)}
                    modal={true}
                    animate={true}

                >
                    <Box
                        width={"large"}
                        pad={"medium"}
                    >
                        <Form
                            value={value}
                            onChange={nextValue => setValue(nextValue)}
                            onReset={() => setValue({})}
                            onSubmit={({ value }) => {submitAction(value)}}
                        >
                            <Heading>Add Produce</Heading>
                            <Box pad={"medium"}>
                                <FormField name="Title" htmlFor="text-input-title" label="Title">
                                    <TextInput id="text-input-title" name="Title" />
                                </FormField>
                                <FormField name="Description" htmlFor="text-input-description" label="Description">
                                    <TextArea
                                        placeholder="Description of the produce"
                                        value={description}
                                        onChange={event => setDescription(event.target.value)}
                                    />
                                </FormField>

                                <Box pad={"small"}>
                                    <Text>Upload a picture of your veggies!</Text>
                                </Box>
                                    <FileInput
                                    name="file"
                                    onChange={event => {
                                        const fileList = event.target.files;
                                        setImageFile(fileList[0])
                                        // for (let i = 0; i < fileList.length; i += 1) {
                                        //     const pdf_blob = await getBase64(file) as string;
                                        //     setImageFile(fileList[i]);
                                        // }
                                    }}
                                />

                                <Box pad={"small"}>
                                    <Text >What kind of veggies do you wanna trade?</Text>
                                </Box>
                                    <Select
                                    options={[
                                        'Artichoke',
                                        'Arugula',
                                        'Asparagus',
                                        'Avocado',
                                        'Bamboo Shoots',
                                        'Bean Sprouts',
                                        'Beans',
                                        'Beet',
                                        'Belgian Endive',
                                        'Bell Pepper',
                                        'Bitter Melon/Bitter Gourd',
                                        'Bok Choy/Bok Choi/Pak Choy',
                                        'Broccoli',
                                        'Brussels Sprouts',
                                        'Burdock Root/Gobo',
                                        'Cabbage',
                                        'Calabash',
                                        'Capers',
                                        'Carrot',
                                        'Cassava/Yuca',
                                        'Cauliflower',
                                        'Celery',
                                        'Celery Root/Celeriac',
                                        'Celtuce',
                                        'Chayote',
                                        ]}
                                    value={produceType}
                                    onChange={({ option }) => setProduceType(option)}
                                />
                            </Box>
                            <Box direction="row" gap="medium">
                                <Button type="submit" primary label="Submit" />
                                <Button type="reset" label="Reset" />
                            </Box>
                        </Form>
                    </Box>
                </Layer>
            )}
        </Page>
    )
}

export default Dashboard


















